// Components==============
import Button from 'components/UI/Button/Button';
import Spinner from 'components/UI/Spinner/Spinner';
import { HomeContext } from 'pages/Home/Home';
import React, { useContext } from 'react';
import { GlobalHeroContentContext } from 'utilities/GlobalContext/GlobalHeroContent';
import './HeroCard.module.scss';
// =========================

export default function HeroCard() {
  const { heroContent } = useContext(GlobalHeroContentContext);
  const { loading } = useContext(HomeContext);

  const image = `/storage/${heroContent?.image}`;

  return (
    <div
      styleName={`wrapper ${
        heroContent?.gebruik_afbeelding_als_achtergrond ? 'with-background' : ''
      }`}
      style={{
        backgroundImage: heroContent?.gebruik_afbeelding_als_achtergrond
          ? `url(${image})`
          : '',
      }}
    >
      <div styleName="overlay" />
      <div styleName="content">
        <h1>
          {heroContent?.title} <Spinner loading={loading} />
        </h1>
        <p>{heroContent?.text}</p>
        <Button to={heroContent?.cta_link}>{heroContent?.cta_text}</Button>
      </div>
      {!heroContent?.gebruik_afbeelding_als_achtergrond && (
        <img src={image} alt={heroContent?.title} />
      )}
    </div>
  );
}
